// src/pages/Solicitacoes/components/OSGroupTable.jsx
import React from 'react';
import {
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material';
import StatusChip from './StatusChip';
import ActionsMenu from './ActionsMenu';
import {parse, format, isValid} from 'date-fns';

export default function OSGroupTable({
    items,
    anchorEl,
    menuOpenId,
    handleMenuClick,
    handleMenuClose,
    handleMenuAction,
    podeMostrarMenu,
}) {
    return (
        <TableContainer
            component={Paper}
            sx={{
                'border': '1px solid #ccc',
                'borderRadius': 3,
                '& .MuiTableCell-root': {padding: '4px 5px'},
            }}
        >
            <Table size="small">
                <TableHead sx={{bgcolor: '#f9fafb'}}>
                    <TableRow>
                        <TableCell
                            align="center"
                            sx={{typography: 'subtitle2', fontWeight: 600}}
                        ></TableCell>
                        <TableCell align="center" sx={{typography: 'subtitle2', fontWeight: 600}}>
                            Código
                        </TableCell>
                        <TableCell align="center" sx={{typography: 'subtitle2', fontWeight: 600}}>
                            Descrição
                        </TableCell>
                        <TableCell align="center" sx={{typography: 'subtitle2', fontWeight: 600}}>
                            Qtd
                        </TableCell>
                        <TableCell align="center" sx={{typography: 'subtitle2', fontWeight: 600}}>
                            Valor unitário
                        </TableCell>

                        <TableCell align="center" sx={{typography: 'subtitle2', fontWeight: 600}}>
                            Tipo de serviço
                        </TableCell>
                        <TableCell align="center" sx={{typography: 'subtitle2', fontWeight: 600}}>
                            Valor orçamento
                        </TableCell>
                        <TableCell align="center" sx={{typography: 'subtitle2', fontWeight: 600}}>
                            Valor aprovado
                        </TableCell>
                        <TableCell align="center" sx={{typography: 'subtitle2', fontWeight: 600}}>
                            Data aprovação
                        </TableCell>
                        <TableCell align="center" sx={{typography: 'subtitle2', fontWeight: 600}}>
                            Aprovado por
                        </TableCell>
                        <TableCell align="center" sx={{typography: 'subtitle2', fontWeight: 600}}>
                            Pedido Compra
                        </TableCell>
                        <TableCell align="center" sx={{typography: 'subtitle2', fontWeight: 600}}>
                            Ações
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map((nota) => {
                        const valorUniFmt =
                            nota.valorUnitario != null
                                ? new Intl.NumberFormat('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                  }).format(nota.valorUnitario)
                                : '-';
                        const valorOrcFmt =
                            nota.valorOrcamento != null
                                ? new Intl.NumberFormat('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                  }).format(nota.valorOrcamento)
                                : '-';
                        const valorAprFmt =
                            nota.valorAprovado != null
                                ? new Intl.NumberFormat('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                  }).format(nota.valorAprovado)
                                : '-';

                        // formata data yyyyMMdd → dd/MM/yyyy
                        let dataFmt = '-';
                        if (nota.dataAprovacao) {
                            const dt = parse(nota.dataAprovacao, 'yyyyMMdd', new Date());
                            dataFmt = isValid(dt) ? format(dt, 'dd/MM/yyyy') : '-';
                        }
                        return (
                            <TableRow key={nota.id} hover>
                                <TableCell align="center">
                                    <StatusChip status={nota.status} />
                                </TableCell>
                                <TableCell align="center" sx={{typography: 'body2'}}>
                                    {nota.codigo}
                                </TableCell>
                                <TableCell align="center" sx={{typography: 'body2'}}>
                                    {nota.descricao}
                                </TableCell>
                                <TableCell align="center" sx={{typography: 'body2'}}>
                                    {nota.quantidade}
                                </TableCell>
                                <TableCell align="center" sx={{typography: 'body2'}}>
                                    {valorUniFmt}
                                </TableCell>
                                <TableCell align="center" sx={{typography: 'body2'}}>
                                    {nota.servico}
                                </TableCell>
                                <TableCell align="center" sx={{typography: 'body2'}}>
                                    {valorOrcFmt}
                                </TableCell>
                                <TableCell align="center" sx={{typography: 'body2'}}>
                                    {valorAprFmt}
                                </TableCell>
                                <TableCell align="center" sx={{typography: 'body2'}}>
                                    {dataFmt}
                                </TableCell>
                                <TableCell align="center" sx={{typography: 'body2'}}>
                                    {nota.aprovadoPor || '-'}
                                </TableCell>
                                <TableCell align="center" sx={{typography: 'body2'}}>
                                    {nota.pedidoCompra || '-'}
                                </TableCell>

                                <TableCell align="center">
                                    <ActionsMenu
                                        nota={nota}
                                        anchorEl={anchorEl}
                                        menuOpenId={menuOpenId}
                                        handleMenuClick={handleMenuClick}
                                        handleMenuClose={handleMenuClose}
                                        handleMenuAction={handleMenuAction}
                                        podeMostrarMenu={podeMostrarMenu}
                                    />
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
